exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentFooterComponent---3UxcO {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---1Q6NJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---24vuv, .downloadSignInCards---E6UUp,\n.unassign---3MI5B,\n.bulkPasswordChange---FyQ4x,\n.deleteStudents---24Deh {\n  margin-left: 10px; }\n\n.buttonContainer---1Q6NJ > span {\n  padding-top: 10px; }\n\n.svgIconContainer---2tdOJ {\n  width: 1px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2tdOJ svg path {\n    fill: none !important; }\n\n.highlight---3MgVe {\n  color: #32a8a7; }\n", ""]);

// exports
exports.locals = {
	"studentFooterComponent": "studentFooterComponent---3UxcO",
	"buttonContainer": "buttonContainer---1Q6NJ",
	"footerButton": "footerButton---24vuv",
	"downloadSignInCards": "downloadSignInCards---E6UUp",
	"unassign": "unassign---3MI5B",
	"bulkPasswordChange": "bulkPasswordChange---FyQ4x",
	"deleteStudents": "deleteStudents---24Deh",
	"svgIconContainer": "svgIconContainer---2tdOJ",
	"highlight": "highlight---3MgVe"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/student-footer/index.scss
// module id = 1193
// module chunks = 3